import PropTypes from 'prop-types';

function ServiceCard({ icon, title, description }) {
  const iconStyles = {
    backgroundColor: '#5BC7D6',
    color: '#0F7E8D'
  };

  return (
    <div style={{
      textAlign: 'center',
      padding: '1.5rem'
    }}>
      <div style={{
        width: '4rem',
        height: '4rem',
        margin: '0 auto',
        marginBottom: '1rem',
        borderRadius: '9999px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.5rem',
        ...iconStyles
      }}>
        {typeof icon === 'string' ? (
          <img src={icon} alt={title} style={{ width: '2rem', height: '2rem' }} />
        ) : (
          <icon.type {...icon.props} />
        )}
      </div>
      <h3 style={{
        fontSize: '1.25rem',
        fontWeight: '600',
        marginBottom: '0.75rem'
      }}>{title}</h3>
      <p style={{
        color: '#4B5563'
      }}>{description}</p>
    </div>
  );
}

ServiceCard.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.elementType
  ]).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

function Services() {
  const services = [
    {
      icon: '/images/icon/image.png',
      title: "Property Development Investment Consulting",
      description: "Data-driven property development consulting, helping clients identify profitable opportunities, assess risks, and maximise returns with data-driven insights."
    },
    {
      icon: '/images/icon/image1.png',
      title: "Property Development Feasibility Study",
      description: "Empowered by self-developed big-data analysis system, feasibility studies analyse market trends, regulatory requirements, and financial projections to ensure your property development project is viable and strategically positioned."
    },
    {
      icon: '/images/icon/image2.png',
      title: "Property Investment Portfolio Optimisation",
      description: "We optimise property investment portfolios by evaluating asset performance, identifying growth opportunities, and structuring investments for long-term stability and high returns."
    },
    {
      icon: '/images/icon/image3.png',
      title: "Residential Home Building and Advice",
      description: "From design to construction, we offer comprehensive support for residential home building, ensuring high-quality craftsmanship and cost-effective solutions tailored to your needs."
    },
    {
      icon: '/images/icon/image4.png',
      title: "First-Home Portfolio Planning",
      description: "First time buying a house? We provide insights on market entry, financing options, and long-term growth strategies for all new buyers."
    },
    {
      icon: '/images/icon/image5.png',
      title: "Customised Property Development",
      description: "Tailored property development solutions to suit your specific goals, covering site selection, project management, and financial planning to deliver successful, high-value developments."
    }
  ];

  return (
    <div style={{
      width: '100vw',
      padding: '5rem 0',
      backgroundColor: '#F9FAFB'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 2rem'
      }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '4rem'
        }}>
          <h2 style={{
            fontSize: '2.25rem',
            fontWeight: 'bold',
            marginBottom: '1rem'
          }}>Our Property Services</h2>
          <p style={{color: '#91268F'}}>Expert solutions for property development and investment</p>
        </div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '2rem'
        }}>
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Services; 